import { TurnStatus } from '@db8/shared'

export const botMessageMap: Record<TurnStatus, string> = {
  [TurnStatus.THINKING]: 'Generating AI argument…',
  [TurnStatus.PAUSED]: 'Paused. Press play to continue this turn or press next to proceed.',
  [TurnStatus.PLAYING]: 'Playing audio',
  [TurnStatus.TURN_COMPLETE]: 'Turn complete. Press Next to continue.',
  [TurnStatus.RESTART]: 'Replaying audio from start…',
  [TurnStatus.READY]: 'Ready — press Play when ready.',
  [TurnStatus.CANCELLED]: 'Bot generation cancelled.',
  [TurnStatus.RECORDING]: 'Playing audio',
  [TurnStatus.TURN_STARTING]: 'Updating hall data…',
}

export const userMessageMap: Record<TurnStatus, string> = {
  [TurnStatus.THINKING]: 'Preparing turn…',
  [TurnStatus.RECORDING]: 'Recording…',
  [TurnStatus.PAUSED]: 'Paused. Press play to continue this turn or press next to proceed',
  [TurnStatus.RESTART]: 'Turn restarted. Transcript cleared.',
  [TurnStatus.PLAYING]: 'Speaking…',
  [TurnStatus.TURN_COMPLETE]: 'Turn complete. Press Next to continue.',
  [TurnStatus.READY]: 'Ready — press Play when ready.',
  [TurnStatus.CANCELLED]: 'Cancelled.',
  [TurnStatus.TURN_STARTING]: 'Updating hall data…',
}

export const botErrorMap = {
  NONE: '',
  FETCH_FAILED: 'Error fetching AI argument.',
  TTS_FAILED: 'Error generating audio. Please try again.',
}
